class CCMEnrollementDialogUtils {
  static CurrentDateAndTime = (): string => {
    return (
      new Date().toLocaleDateString() +
      ' ' +
      new Date().toLocaleTimeString('en-US')
    );
  };

  static CurrentMonthAndYear = (): string => {
    return new Date().toLocaleString('default', {
      month: 'long',
      year: 'numeric'
    });
  };

  static CurrentDate = (): string => {
    return new Date().toLocaleDateString('en-US', {
      month: '2-digit',
      day: '2-digit',
      year: 'numeric'
    });
  };
}

export default CCMEnrollementDialogUtils;
